// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import HighscoreGenerationSurvey from "./highscore-generation-survey.js"
import Team from "./team.js"

const modelClassData = {
  "attributes": {
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "placement": {
      "column": {
        "default": null,
        "name": "placement",
        "null": false,
        "type": "integer"
      },
      "name": "placement",
      "selected_by_default": null,
      "translated": null
    },
    "score": {
      "column": {
        "default": null,
        "name": "score",
        "null": false,
        "type": "integer"
      },
      "name": "score",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "HighscoreGenerationTeam",
  "collectionKey": "highscore_generation_teams",
  "collectionName": "highscore_generation_teams",
  "i18nKey": "highscore_generation_team",
  "camelizedLower": "highscoreGenerationTeam",
  "name": "HighscoreGenerationTeam",
  "nameDasherized": "highscore-generation-team",
  "pluralName": "highscore_generation_teams",
  "ransackable_associations": [
    {
      "className": "Competition",
      "collectionName": "competitions",
      "foreignKey": "competition_id",
      "name": "competition",
      "macro": "has_one",
      "resource_name": "Competition",
      "through": "highscore_generation_survey"
    },
    {
      "className": "Highscore",
      "collectionName": "highscores",
      "foreignKey": "highscore_id",
      "name": "highscore",
      "macro": "has_one",
      "resource_name": "Highscore",
      "through": "highscore_generation"
    },
    {
      "className": "HighscoreGeneration",
      "collectionName": "highscore_generations",
      "foreignKey": "highscore_generation_id",
      "name": "highscore_generation",
      "macro": "has_one",
      "resource_name": "HighscoreGeneration",
      "through": "highscore_generation_survey"
    },
    {
      "className": "HighscoreGenerationSurvey",
      "collectionName": "highscore_generation_surveys",
      "foreignKey": "highscore_generation_survey_id",
      "name": "highscore_generation_survey",
      "macro": "belongs_to",
      "resource_name": "HighscoreGenerationSurvey",
      "through": null
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Team",
      "collectionName": "teams",
      "foreignKey": "team_id",
      "name": "team",
      "macro": "belongs_to",
      "resource_name": "Team",
      "through": null
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "highscore_generation_survey_id",
      "column": {
        "default": null,
        "name": "highscore_generation_survey_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "old_highscore_generation_survey_id",
      "column": {
        "default": null,
        "name": "old_highscore_generation_survey_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_id",
      "column": {
        "default": null,
        "name": "old_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_team_id",
      "column": {
        "default": null,
        "name": "old_team_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "placement",
      "column": {
        "default": null,
        "name": "placement",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "score",
      "column": {
        "default": null,
        "name": "score",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "team_id",
      "column": {
        "default": null,
        "name": "team_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "HighscoreGenerationSurvey",
      "collectionName": "highscore_generation_surveys",
      "foreignKey": "highscore_generation_survey_id",
      "name": "highscore_generation_survey",
      "macro": "belongs_to",
      "resource_name": "HighscoreGenerationSurvey",
      "through": null
    },
    {
      "className": "Team",
      "collectionName": "teams",
      "foreignKey": "team_id",
      "name": "team",
      "macro": "belongs_to",
      "resource_name": "Team",
      "through": null
    }
  ],
  "paramKey": "highscore_generation_team",
  "primaryKey": "id"
}

/** Frontend model for HighscoreGenerationTeam. */
export default class HighscoreGenerationTeam extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {number} */
  placement() {
    return this.readAttributeUnderscore("placement")
  }

  /** @returns {boolean} */
  hasPlacement() {
    const value = this.placement()

    return this._isPresent(value)
  }

  /** @returns {number} */
  score() {
    return this.readAttributeUnderscore("score")
  }

  /** @returns {boolean} */
  hasScore() {
    const value = this.score()

    return this._isPresent(value)
  }

  /** @returns {import("./highscore-generation-survey.js").default | null} */
  highscoreGenerationSurvey() {
    return this._readBelongsToReflection({modelClass: HighscoreGenerationSurvey, reflectionName: "highscore_generation_survey"})
  }

  /** @returns {Promise<import("./highscore-generation-survey.js").default | null>} */
  loadHighscoreGenerationSurvey() {
    if (!("highscoreGenerationSurveyId" in this)) throw new Error("Foreign key method wasn't defined: highscoreGenerationSurveyId")

    const id = this.highscoreGenerationSurveyId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "highscore_generation_survey",
        model: this,
        modelClass: HighscoreGenerationSurvey
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./highscore-generation-survey.js").default | null>} */
  ensureHighscoreGenerationSurveyLoaded() {
    return this.ensureAssociationLoaded("highscore_generation_survey")
  }

  /** @returns {import("./team.js").default | null} */
  team() {
    return this._readBelongsToReflection({modelClass: Team, reflectionName: "team"})
  }

  /** @returns {Promise<import("./team.js").default | null>} */
  loadTeam() {
    if (!("teamId" in this)) throw new Error("Foreign key method wasn't defined: teamId")

    const id = this.teamId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "team",
        model: this,
        modelClass: Team
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./team.js").default | null>} */
  ensureTeamLoaded() {
    return this.ensureAssociationLoaded("team")
  }
}
